export default __webpack_public_path__ + "static/bg-innovation--mobile-fd86237ab50633d273f07e513994c870.webp";